import { render, staticRenderFns } from "./SettingsBotThemeTabs.vue?vue&type=template&id=c0aa4da2&"
import script from "./SettingsBotThemeTabs.vue?vue&type=script&lang=js&"
export * from "./SettingsBotThemeTabs.vue?vue&type=script&lang=js&"
import style0 from "./SettingsBotThemeTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports